// src/pages/LegalPage.js

import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export default function LegalPage() {
  const { i18n } = useTranslation();
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    const lang = i18n.language || "fr"; // Default to French
    fetch(`/locales/${lang}/legal.json`)
      .then((res) => res.json())
      .then(setLegal)
      .catch(() => console.error("❌ Erreur lors du chargement des mentions légales"));
  }, [i18n.language]);

  if (!legal) {
    return <p className="text-center mt-10">📄 Chargement des mentions légales...</p>;
  }

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10 sm:py-14 text-slate-800">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#245580] mb-3">{legal.title}</h1>
      <p className="text-sm text-slate-600 mb-10">{legal.last_update}</p>

      {legal.sections.map((section, index) => (
        <section key={index} className="mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-[#245580] mb-4">{section.title}</h2>
          <p className="text-base leading-8">{section.body}</p>
        </section>
      ))}
    </div>
  );
}
